import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URLS } from './config';
import './PaymentReturn.css';

const PaymentReturn = ({ setToast }) => {
  const [status, setStatus] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get('session_id');

    const Stripe_returnAPI = API_URLS.STRIPE_SESSION_STATUS + `?session_id=${sessionId}`;

    fetch(Stripe_returnAPI)
      .then((res) => res.json())
      .then((data) => {
        setStatus(data.status);

      });
  }, []);

  useEffect(() => {
    if (status === 'open') {
      navigate('/packages');
    } else if (status === 'complete') {
      if (setToast) {
        setToast({ message: 'Payment completed successfully!', type: 'success' });
      }
      const timer = setTimeout(() => {
        navigate('/account');
      }, 3000); // Redirect after 3 seconds
      return () => clearTimeout(timer); // Clear timeout if component unmounts
    }
  }, [status, navigate, setToast]);


  return (
      <section id="success">
          <p>Loading...</p>
      </section>
  );
};

export default PaymentReturn;
